<template>
  <component :is="type" :href="link" class="Alert" ref="alert">
    <div class="inner">
      <button v-if="!preventClose" class="Alert__close" @click.prevent="onClose">
        <Icon name="cross" />
      </button>
      <h4 v-if="title">{{ title }}</h4>
      <slot />
    </div>
  </component>
</template>

<script>
  import { ref, onMounted, nextTick } from 'vue'
  import { useAlerts } from '@/store/alerts'
  import gsap from 'gsap'
  import Icon from '@components/Icon'

  export default {
    components : { Icon },
    props: [ 'title', 'state', 'id', 'preventClose', 'link'],
    setup(props) {

      const alert = ref(null)

      const onClose = () => {
        gsap.to(alert.value, { autoAlpha: 0, xPercent: 100, ease: 'power3.inOut', onComplete : () => {
          nextTick(() => useAlerts.delete(props.id))
        }})
      }

      onMounted(() => {
        nextTick(() => gsap.from(alert.value, { yPercent: 150, duration:1.2, ease: 'expo.out', delay: 0.5}))
      })

      return {
        type: props.link ? 'inertia-link' : 'div',
        alert,
        onClose
      }
    }
  }
</script>

<style lang="scss">
  @import "~@sass/components/_Alert.scss";
</style>
